import { Component } from '@angular/core';

@Component({
  selector: 'app-download',
  templateUrl: './app-download.component.html',
  styleUrls: ['./app-download.component.scss'],
  standalone: true,
  imports: []
})
export class AppDownloadComponent {
  downloadApp(): void {
    // TODO: Replace with actual app download URL
    window.location.href = 'https://onelink.to/ymbp8e';
  }
}
